import { StanButton } from '@/components';
import { LuCircleCheck } from 'react-icons/lu';
import { BUTTON_LABELS, BUTTON_NAMES, ONBOARDING_CONTENT } from '../../constants';

interface SuccessProps {
    onComplete: () => void;
}

export const Success = ({ onComplete }: SuccessProps) => {
    const content = ONBOARDING_CONTENT.SUCCESS_STEP;

    return (
        <div className='mt-4 mb-8 flex w-full max-w-[375px] flex-col items-center justify-center gap-6'>
            {/* Success Icon */}
            <div className='my-8 mb-2.5'>
                <LuCircleCheck className='text-semantic-fg-base size-[78px]' />
            </div>

            {/* Title */}
            <p className='text-semantic-fg-base w-full text-center text-[28px] leading-tight font-extrabold tracking-tight'>
                {content.title}
            </p>

            {/* Subtitle */}
            <div className='text-gray font-inter w-full text-center text-base leading-snug'>{content.subtitle}</div>

            {/* Continue Button */}
            <div className='mt-6 w-full'>
                <StanButton name={BUTTON_NAMES.ONBOARDING_SUCCESS} onClick={onComplete} className='w-full'>
                    {BUTTON_LABELS.LETS_GO}
                </StanButton>
            </div>
        </div>
    );
};
